"use strict";

var _defineProperty = require("/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _internal = require("../../theme/internal");

var _style = require("../../style");

var genStatisticStyle = function genStatisticStyle(token) {
  var _$concat, _Object$assign;

  var componentCls = token.componentCls,
      marginXXS = token.marginXXS,
      padding = token.padding,
      colorTextDescription = token.colorTextDescription,
      statisticTitleFontSize = token.statisticTitleFontSize,
      colorTextHeading = token.colorTextHeading,
      statisticContentFontSize = token.statisticContentFontSize,
      statisticFontFamily = token.statisticFontFamily;
  return _defineProperty({}, "".concat(componentCls), Object.assign(Object.assign({}, (0, _style.resetComponent)(token)), (_Object$assign = {}, _defineProperty(_Object$assign, "".concat(componentCls, "-title"), {
    marginBottom: marginXXS,
    color: colorTextDescription,
    fontSize: statisticTitleFontSize
  }), _defineProperty(_Object$assign, "".concat(componentCls, "-skeleton"), {
    paddingTop: padding
  }), _defineProperty(_Object$assign, "".concat(componentCls, "-content"), (_$concat = {
    color: colorTextHeading,
    fontSize: statisticContentFontSize,
    fontFamily: statisticFontFamily
  }, _defineProperty(_$concat, "".concat(componentCls, "-content-value"), {
    display: 'inline-block',
    direction: 'ltr'
  }), _defineProperty(_$concat, "".concat(componentCls, "-content-prefix, ").concat(componentCls, "-content-suffix"), {
    display: 'inline-block'
  }), _defineProperty(_$concat, "".concat(componentCls, "-content-prefix"), {
    marginInlineEnd: marginXXS
  }), _defineProperty(_$concat, "".concat(componentCls, "-content-suffix"), {
    marginInlineStart: marginXXS
  }), _$concat)), _Object$assign)));
}; // ============================== Export ==============================


var _default = (0, _internal.genComponentStyleHook)('Statistic', function (token) {
  var fontSizeHeading3 = token.fontSizeHeading3,
      fontSize = token.fontSize,
      fontFamily = token.fontFamily;
  var statisticToken = (0, _internal.mergeToken)(token, {
    statisticTitleFontSize: fontSize,
    statisticContentFontSize: fontSizeHeading3,
    statisticFontFamily: fontFamily
  });
  return [genStatisticStyle(statisticToken)];
});

exports.default = _default;